<template>
	<div
		v-if="articles.length > 0"
		class="grid grid-cols-2 gap-x-2 gap-y-6 md:grid-cols-3 md:gap-x-6 md:gap-y-9 lg:grid-cols-4"
	>
		<v-storyblok-article-card-big
			v-for="article in articles"
			:key="article.id"
			:article="article"
			show-recommendation-badge
		/>
	</div>
</template>

<script setup lang="ts">
import {useStoryblokArticles} from "@pkg/shared/composables/use-storyblok-articles";

const properties = defineProps<{
	categories: string[];
}>();

const {data: articlesResponse} = useStoryblokArticles({
	featured: true,
	categories: toRef(properties, "categories"),
	perPage: 15,
	page: 1,
});

const articles = computed(() =>
	articlesResponse.value ? articlesResponse.value.stories : [],
);
</script>
